import React from 'react'
import PodcastsIcon from '@mui/icons-material/Podcasts'

import MediaModal from './MediaModal'
import { PodcastModalStyle } from '../styles'

const config = {
    Icon: PodcastsIcon,
    style: PodcastModalStyle,
    favouriteType: 'podcast',
    resourcePath: 'podcasts',
    authorsLabel: 'Series:',
    subKey: 'sub_podcasts',
    subHeading: 'Talks',
    rowKeyPrefix: 'talk',
}

const PodcastModal = (props) => <MediaModal config={config} {...props} />

export default PodcastModal
